import { connect } from 'react-redux';
import { compose } from 'redux';

import { goToAlerts } from './AlertCreateSuccessDialogActions';
import AlertCreateSuccessDialog from './AlertCreateSuccessDialog';

const mapDispatchToProps = (dispatch, ownProps) => ({
  goToAlerts: () => dispatch(goToAlerts(ownProps)),
});

export default compose(connect(null, mapDispatchToProps))(AlertCreateSuccessDialog);
